export default __webpack_public_path__ + "static/media/desktop_banner_claim.16d8833c.jpg";